import { Rows2, Rows4 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Segmented } from "@h2j-data-team/ui";

import type { TableDensity } from "@/lib/use-table-density";

/**
 * Icon-only comfortable/compact switch for a DataTable's `density`. The
 * preference and its storage stay in the app (`useTableDensity`); it goes in the
 * table's `toolbar`.
 */
export function DensityToggle({
  value,
  onChange,
}: {
  value: TableDensity;
  onChange: (value: TableDensity) => void;
}) {
  const { t } = useTranslation("common");
  return (
    <Segmented<TableDensity>
      label={t("density.label")}
      size="compact"
      value={value}
      onValueChange={onChange}
      options={[
        { value: "comfortable", label: t("density.comfortable"), icon: <Rows2 />, hideLabel: true },
        { value: "compact", label: t("density.compact"), icon: <Rows4 />, hideLabel: true },
      ]}
    />
  );
}
